module["exports"] = ["Pty Ltd", "and Sons", "Corp", "Group", "Brothers", "Partners"];